<div class="modal-overlay" (click)="close.emit()">
  <div class="bulk-contract-modal" (click)="$event.stopPropagation()">
    <div class="bulk-contract-header">
      <div>
        <div class="bulk-contract-title">Bulk add code</div>
        <div class="bulk-contract-subtitle">
          A new code will be added for
          <strong>{{ selectedCount }} selected {{ selectedCount === 1 ? 'client' : 'clients' }}</strong>
        </div>
      </div>
      <button class="bulk-contract-close" (click)="close.emit()">&#x2715;</button>
    </div>

    <div class="bulk-contract-body">
      <div class="bulk-contract-section">
        <div class="bulk-contract-label">Selected clients:</div>
        <div class="bulk-contract-clients-preview">
          @for (c of selectedClients.slice(0, 6); track c.id) {
            <span class="client-name-chip">{{ c.name }}</span>
          }
          @if (selectedClients.length > 6) {
            <span class="client-name-chip">+ {{ selectedClients.length - 6 }} more</span>
          }
        </div>
      </div>

      <div class="bulk-contract-label">Template:</div>
      <select class="bulk-contract-date" (change)="selectStencil($event)">
        <option value="" [selected]="!stencilId">Select a template</option>
        @for (item of stencils; track item.id) {
          <option [value]="item.id" [selected]="item.id == stencilId">{{ item.description }}</option>
        }
      </select>

      <div class="bulk-contract-label" style="margin-top:16px;">Expected completion date:</div>
      <input class="bulk-contract-date" type="date"
             [value]="expectedCompletion"
             (input)="expectedCompletion = $any($event.target).value" />
    </div>

    <div class="bulk-contract-footer">
      <button class="bulk-footer-cancel" (click)="close.emit()">Cancel</button>
      <button class="bulk-footer-apply"
              [disabled]="!stencilId || !expectedCompletion || processing"
              (click)="process()">
        {{ processing ? 'Processing...' : 'Process' }}
      </button>
    </div>
  </div>
</div>
